import { useCoworkerProfileStore } from '@/store/coworker-preferences.store';
import { selectBuCode } from '@repo/api-adapters/selectors/customer-assets.selectors';
import { selectServices } from '@repo/api-adapters/selectors/services.selectors';
import { useStoreDetails } from '@repo/hooks';
import type { AssetDataType } from '@repo/types/asset';

import { getServiceEndpoint } from '@/api/helpers.api';
import { getAppConfig } from '@/utils/window.utils';

export const useAssetServices = (data?: AssetDataType): ReturnType<typeof selectServices> => {
    const assetBuCode = selectBuCode(data) ?? '';
    const storeDetailsBaseUrl = getServiceEndpoint(getAppConfig().api.services.classicSalja, 'storeDetails');
    const { data: storeDetails } = useStoreDetails(storeDetailsBaseUrl, assetBuCode);
    const coworkerStoreTimezone = useCoworkerProfileStore((state) => state.store?.TimeZone);

    return selectServices(data, {
        fallbackTimezones: [storeDetails?.TimeZone, coworkerStoreTimezone],
    });
};
